import { serializeActor } from 'ui-product-approvals-common/utils/actorKey';
export const getLockedTemplateApproverActorKeys = template => {
  var _template$approvalSte;
  return new Set(((_template$approvalSte = template === null || template === void 0 ? void 0 : template.approvalSteps) !== null && _template$approvalSte !== void 0 ? _template$approvalSte : []).filter(step => step.locked).map(step => serializeActor(step.actor)));
};
export const getUnavailableTemplateApproverActorKeys = (template, approvers) => {
  if (!(template !== null && template !== void 0 && template.approvalSteps.length)) {
    return new Set();
  }
  const availableActorKeys = new Set(approvers.map(approver => serializeActor(approver.actor)));
  return new Set(template.approvalSteps.filter(step => !availableActorKeys.has(serializeActor(step.actor))).map(step => serializeActor(step.actor)));
};
export const hasUnavailableTemplateApprover = (template, approvers) => getUnavailableTemplateApproverActorKeys(template, approvers).size > 0;
export const getInitialStepGroups = (template, approvers, defaultAgentApprover) => {
  const approversByActorKey = new Map(approvers.map(approver => [serializeActor(approver.actor), approver]));
  const unorderedApprovers = [];
  const approversByOrder = new Map();
  template === null || template === void 0 || template.approvalSteps.forEach(templateStep => {
    var _approversByOrder$get;
    const approver = approversByActorKey.get(serializeActor(templateStep.actor));
    if (!approver) {
      return;
    }
    if (templateStep.order === undefined) {
      unorderedApprovers.push(approver);
      return;
    }
    const stepApprovers = (_approversByOrder$get = approversByOrder.get(templateStep.order)) !== null && _approversByOrder$get !== void 0 ? _approversByOrder$get : [];
    stepApprovers.push(approver);
    approversByOrder.set(templateStep.order, stepApprovers);
  });
  const orderedGroups = [...approversByOrder.entries()].sort(([orderA], [orderB]) => orderA - orderB).map(([, stepApprovers]) => stepApprovers);
  const stepGroups = unorderedApprovers.length > 0 ? [unorderedApprovers, ...orderedGroups] : orderedGroups;
  if (!defaultAgentApprover) {
    return stepGroups;
  }
  if (stepGroups.length === 0) {
    return [[defaultAgentApprover]];
  }
  const [firstStep, ...remainingSteps] = stepGroups;
  return [firstStep.some(approver => serializeActor(approver.actor) === serializeActor(defaultAgentApprover.actor)) ? firstStep : [...firstStep, defaultAgentApprover], ...remainingSteps];
};
export const getLockedTemplateStageIndexes = (template, approvers, renderedStepGroups) => {
  var _template$approvalSte3;
  // An approval may no longer contain every template stage. In that case,
  // map a stage lock to its current group by the locked template actor rather
  // than the template's original ordinal.
  if (renderedStepGroups) {
    var _template$approvalSte2;
    const lockedTemplateActorKeys = new Set(((_template$approvalSte2 = template === null || template === void 0 ? void 0 : template.approvalSteps) !== null && _template$approvalSte2 !== void 0 ? _template$approvalSte2 : []).filter(step => step.stageLocked).map(step => serializeActor(step.actor)));
    return new Set(renderedStepGroups.flatMap((stepGroup, index) => stepGroup.some(approver => lockedTemplateActorKeys.has(serializeActor(approver.actor))) ? [index] : []));
  }
  const availableActorKeys = new Set(approvers.map(approver => serializeActor(approver.actor)));
  const templateSteps = ((_template$approvalSte3 = template === null || template === void 0 ? void 0 : template.approvalSteps) !== null && _template$approvalSte3 !== void 0 ? _template$approvalSte3 : []).filter(step => availableActorKeys.has(serializeActor(step.actor)));
  const unorderedSteps = templateSteps.filter(step => step.order === undefined);
  const orderedStages = new Map();
  templateSteps.forEach(step => {
    var _orderedStages$get;
    if (step.order === undefined) {
      return;
    }
    const stage = (_orderedStages$get = orderedStages.get(step.order)) !== null && _orderedStages$get !== void 0 ? _orderedStages$get : [];
    stage.push(step);
    orderedStages.set(step.order, stage);
  });
  return new Set([...(unorderedSteps.some(step => step.stageLocked) ? [0] : []), ...[...orderedStages.entries()].sort(([firstOrder], [secondOrder]) => firstOrder - secondOrder).flatMap(([, steps], index) => steps.some(step => step.stageLocked) ? [index + (unorderedSteps.length > 0 ? 1 : 0)] : [])]);
};